module.exports = __webpack_public_path__ + "static/media/qr-code.70dc6e37.svg";